import React from 'react';

export default function PopupModal({ isOpen, title, message, onConfirm, onCancel, confirmText = '確定', cancelText = '取消', isDanger = false }) {
  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 9999
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '20px',
        padding: '32px',
        maxWidth: '400px',
        width: '90%',
        boxShadow: '0 25px 60px rgba(0, 0, 0, 0.2)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(255, 255, 255, 0.1)'
      }}>
        <h3 style={{
          fontSize: '1.25rem',
          fontWeight: 'bold',
          color: '#1f2937',
          marginBottom: '16px',
          textAlign: 'center'
        }}>
          {title}
        </h3>
        <p style={{
          color: '#6b7280',
          fontSize: '14px',
          lineHeight: '1.6',
          marginBottom: '24px',
          textAlign: 'center',
          whiteSpace: 'pre-wrap'
        }}>
          {message}
        </p>
        <div style={{ display: 'flex', gap: '12px' }}>
          {onCancel && (
            <button
              onClick={onCancel}
              style={{
                flex: 1, padding: '12px 20px', borderRadius: '12px',
                border: '1px solid #e5e7eb', backgroundColor: '#f9fafb',
                color: '#374151', fontSize: '14px', fontWeight: '500',
                cursor: 'pointer', transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#f3f4f6'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#f9fafb'}
            >
              {cancelText}
            </button>
          )}
          <button
            onClick={onConfirm || onCancel}
            style={{
              flex: 1, padding: '12px 20px', borderRadius: '12px', border: 'none',
              background: isDanger ? '#ef4444' : '#4e8bca',
              color: 'white', fontSize: '14px', fontWeight: '600',
              cursor: 'pointer', transition: 'all 0.2s',
              boxShadow: isDanger ? '0 4px 12px rgba(239, 68, 68, 0.3)' : '0 4px 12px rgba(78, 139, 202, 0.3)'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = isDanger ? '#dc2626' : '#376ba1';
              e.target.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = isDanger ? '#ef4444' : '#4e8bca';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
